module.exports = __webpack_public_path__ + "static/media/trend.9dd4432b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/trend.gif
// module id = 112
// module chunks = 0